const rootConst = 'BRANCH';

export const CREATE_BRANCH = `${rootConst}/CREATE_BRANH`;
export const UPDATE_BRANCH_PROFILE = `${rootConst}/UPDATE_BRANCH_PROFILE`;
export const DELETE_BRANCH = 'DELETE_BRANCH';
export const DETACH_BRANCH = 'DETACH_BRANCH';

export const DELIVERY_TYPE_OPTS = [
  {
    label: 'Same Day Delivery',
    value: 'SAME_DAY_DELIVERY',
    descriptions:
      'Transactions in this branch will be fulfilled with same day delivery couriers',
  },
  {
    label: 'Scheduled Delivery',
    value: 'SCHEDULE_DELIVERY',
    descriptions:
      'Transactions in this branch will be fulfilled with scheduled delivery',
  },
];

export const INIT_FORM = {
  uuid: '',
  vendor_uuid: '',
  // Branch information
  logo_url: '',
  banner: '',
  business_name: '',
  branch_name: '',
  slug: '',
  // Address
  address: {
    pinned_address: '',
    geoloc: '',
    address_details: '',
  },
  // Branch Operation
  is_open: false,
  operation_days: [],
  operation_time: {
    start: '',
    end: '',
  },
  // Manager account
  branch_users: {
    name: '',
    email: '',
    mobile_number: '',
    password: '',
    password_confirmation: '',
  },
  // Advance ordering
  scheduled_days: [],
  scheduled_time: [],
  day_slots: '',
  hour_slots: 0,
  // Order Fulfillment
  has_pickup_options: false,
  delivery_couriers: [],
  delivery_methods: [],
  primary_delivery_courier: '',
  // Delivery Type
  delivery_type: DELIVERY_TYPE_OPTS[0],
  // Payment Methods
  payment_methods: [],
  payment_channels: [],
  primary_payment_channel: '',
  store_operations: [{}],
  is_mfa_enabled: 0,
  default_mfa: null,
};

export const dayOptions = [
  {
    value: 'Mon',
    label: 'Mon',
  },
  {
    value: 'Tue',
    label: 'Tue',
  },
  {
    value: 'Wed',
    label: 'Wed',
  },
  {
    value: 'Thu',
    label: 'Thu',
  },
  {
    value: 'Fri',
    label: 'Fri',
  },
  {
    value: 'Sat',
    label: 'Sat',
  },
  {
    value: 'Sun',
    label: 'Sun',
  },
];

export const GET_PAYMENT_METHOD = `${rootConst}/GET_PAYMENT_METHOD`;
export const GET_DELIVERY_METHOD = `${rootConst}/GET_DELIVERY_METHOD`;
